import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import { TransitionGroup } from 'react-transition-group';
import { FormHelperText, Fade, makeStyles } from '@material-ui/core';
import CreatableText from './creatableText';
import CustomButton from '../customButton';
import {
  removeObjectFromArray,
  replaceObjectInList,
} from '../../../utility/helpers';

const useStyles = makeStyles(({ spacing }) => ({
  textsWrapper: {
    display: 'grid',
    width: '100%',
    gridRowGap: 24,
  },
  addButton: {
    marginTop: spacing(6),
  },
}));

const CreatableTextsField = ({
  translations,
  texts = [],
  field,
  errors = null,
  onChange,
}) => {
  const classes = useStyles();

  const onAdd = useCallback(() => {
    return onChange([...texts, { id: nanoid(), label: '' }]);
  }, [texts, onChange]);

  const onDelete = useCallback(
    text => {
      onChange(removeObjectFromArray(texts, text));
    },
    [texts, onChange]
  );

  const handleChangeTask = useCallback(
    (textValueIndex, textValue) => {
      onChange(replaceObjectInList(texts, textValueIndex, textValue));
    },
    [texts, onChange]
  );

  return (
    <div>
      {translations.label && (
        <FormHelperText>{translations.label}</FormHelperText>
      )}
      <TransitionGroup className={classes.textsWrapper}>
        {texts.map((textValue, index) => (
          <Fade key={`text_item_${textValue.id}`} in unmountOnExit>
            <div>
              <CreatableText
                translations={translations}
                index={index}
                isDisabled={texts.length === 1}
                text={textValue}
                field={field}
                error={errors?.[textValue.id]}
                onDelete={onDelete}
                onChange={handleChangeTask}
              />
            </div>
          </Fade>
        ))}
      </TransitionGroup>
      <CustomButton
        className={classes.addButton}
        type="addWithTextDarkSlimNew"
        onClick={onAdd}
        fullWidth
      >
        {translations.addButton}
      </CustomButton>
    </div>
  );
};

CreatableTextsField.propTypes = {
  translations: PropTypes.object.isRequired,
  texts: PropTypes.arrayOf(PropTypes.object),
  field: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default CreatableTextsField;
